export interface CpsPathState {
  assetId: string
  pathToken: string
}

export const useCpsPathState = () => useState<CpsPathState | null>('cps-path', () => null)
